import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {HttpRequestErrorHandler} from '@rbaip/ui-component';
import {appConfig} from '../app.config';
import {Asset} from '../domain/item';

@Injectable({
  providedIn: 'root'
})
export class ItemSummaryAssetsService {
  private searchString: string;
  private filterColumnNameValue: Map<string, Array<string>>;
  private initiator: string;

  private readonly moveAssetsBackToOpportunityUrl = '/api/contracts/:contractId/assets/back-to-opportunity';
  private readonly getAssetsFromEquipIdsUrl = '/api/assets/equip-ids?equipIds=:equipIds';
  private readonly moveAssetsBackToWipUrl = '/api/assets/back-to-wip';
  private readonly moveAssetsToHoldingPenUrl = '/api/assets/move-to-holding-pen';
  private readonly moveAssetsToAnotherOpportunityUrl = '/api/assets/move-to-opportunity/:opportunityId/retain-sale-info/:retainSaleInfo';
  private readonly moveAssetsToAnotherContractUrl = '/api/assets/move-to-contract/:contractId/send-to-operations/:sendToOperations/retain-sale-info/:retainSaleInfo';
  private readonly moveAssetsToAnotherEventUrl = '/api/assets/move-to-another-event/opportunity/:opportunityId';
  private readonly componentizeditemsUrl: string = '/api/auction-events/:auctionEventId/equipments/componentized-items';
  private readonly checkOperationalEntityUrl = '/api/assets/check-operational-entity/opportunity/:opportunityId';

  constructor(private http: HttpClient) {
    this.init();
  }
  private init(): void {
    this.searchString = '';
    this.filterColumnNameValue = new Map<string, Array<string>>();
    this.initiator = '';
  }

  public getSandBoxUrl(): Observable<any>  {
    const url = '/api/opportunity/sales-hub-url';
    return this.http.get<any>(url, appConfig.httpOptions);
  }


  public updateDoesCustomerOwesMoney(assetPackageId: number, doesCustomerOwes: boolean): Observable<any> {
    const url = `/api/asset-package/${assetPackageId}/doesCustomerOwes`;

    const body = JSON.stringify(doesCustomerOwes);
    return this.http.put(url, body, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('updateCustomerOwes', null))
      );
  }

  public getEquipIdsFromAssets(assets: Asset[]): string {
    return assets.map(asset => {
      return asset.equipId;
    }).join(',');
  }

  public getAssetsFromEquipIds(equipIds: string): Observable<any> {
    const url = this.getAssetsFromEquipIdsUrl.replace(':equipIds', equipIds);
    return this.http.get<any>(url, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('getAssetsFromEquipIds', false))
      );
  }

  public moveAssetsBackToOpportunity(contractId: number, assets: Asset[]): Observable<any> {
    const url = this.moveAssetsBackToOpportunityUrl.replace(':contractId', String(contractId));
    return this.http.post<any>(url, assets, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('moveAssetsBackToOpportunity', false))
      );
  }

  public moveAssetsBackToWip(assets: Asset[]): Observable<any> {
    const url = this.moveAssetsBackToWipUrl;
    return this.http.post<any>(url, assets, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('moveAssetsBackToWip', false))
      );
  }

  public moveAssetsToHoldingPen(assets: Asset[]): Observable<any> {
    const url = this.moveAssetsToHoldingPenUrl;
    return this.http.post<any>(url, assets, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('moveAssetsToHoldingPen', false))
      );
  }

  public moveAssetsToAnotherOpportunity(opportunityId: number, retainSaleInfo: string, assets: Asset[]): Observable<any> {
    const url = this.moveAssetsToAnotherOpportunityUrl.replace(':opportunityId', String(opportunityId))
                                                      .replace(':retainSaleInfo', retainSaleInfo);
    return this.http.post<any>(url, assets, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('moveAssetsToAnotherOpportunity', false))
      );
  }

  public moveAssetsToAnotherContract(contractId: number, sendToOperations: string, retainSaleInfo: string, assets: Asset[]): Observable<any> {
    const url = this.moveAssetsToAnotherContractUrl.replace(':contractId', String(contractId))
                                                   .replace(':sendToOperations', sendToOperations)
                                                   .replace(':retainSaleInfo', retainSaleInfo);
    return this.http.post<any>(url, assets, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('moveAssetsToAnotherContract', false))
      );
  }

  public moveAssetsToAnotherEvent(opportunityId: number, assets: Asset[]): Observable<any> {
    const url = this.moveAssetsToAnotherEventUrl.replace(':opportunityId', String(opportunityId));
    return this.http.post<any>(url, assets, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('moveAssetsToAnotherEvent', false))
      );
  }

  public getComponentizedItems(auctionEventId: number, equipmentIds: Array<number>): Observable<any> {
    let url = this.componentizeditemsUrl;
    url = url.replace(':auctionEventId', String(auctionEventId));
    return this.http.post(url, equipmentIds, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('getComponentizedItems', {}))
      );
  }

  public checkOperationalEntity(opportunityId: number, assets: Asset[]): Observable<any> {
    const url = this.checkOperationalEntityUrl.replace(':opportunityId', String(opportunityId));
    return this.http.post<any>(url, assets, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('checkOperationalEntity', false))
      );
  }
}
